import { render, staticRenderFns } from "./PaidUser.vue?vue&type=template&id=6cd20568&scoped=true"
import script from "./PaidUser.vue?vue&type=script&lang=js"
export * from "./PaidUser.vue?vue&type=script&lang=js"
import style0 from "./PaidUser.vue?vue&type=style&index=0&id=6cd20568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd20568",
  null
  
)

export default component.exports